.container {
}

.image {
  object-fit: cover;
  width: 100%;
  height: 320px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.3);
}

.defaultImage {
  object-fit: contain;
}

.buyButton {
  position: fixed;
  width: calc(100% - 32px);
  max-width: calc(750px - 32px);
  bottom: 20px;
  z-index: 10000;
}

.modalPartners {
  max-height: 300px;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

/* Sold / reserved / in-escrow banner shown instead of the buy controls. */
.unavailable {
  position: fixed;
  width: calc(100% - 32px);
  max-width: calc(750px - 32px);
  bottom: 20px;
  z-index: 10000;
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(255, 170, 0, 0.12);
  border: 1px solid rgba(255, 170, 0, 0.35);
  backdrop-filter: blur(8px);
}
